var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCloseXCircleGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCloseXCircleGreen") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M883.970153,765.029847 C883.69655,764.756245 883.253486,764.756245 882.980574,765.029847 L879.996514,768.013871 L877.054139,765.071532 C876.782607,764.8 876.343028,764.8 876.072222,765.071532 C875.80069,765.343065 875.80069,765.782643 876.072222,766.05345 L879.014597,768.995824 L876.052106,771.958315 C875.778504,772.231917 875.778504,772.674946 876.052106,772.947894 C876.325708,773.220842 876.768773,773.220842 877.041685,772.947894 L880.004212,769.985403 L882.94655,772.927741 C883.218083,773.199274 883.657662,773.199274 883.928504,772.927741 C884.200036,772.656209 884.200036,772.21663 883.928504,771.945788 L880.986129,769.00345 L883.970189,766.019426 C884.243755,765.746514 884.243755,765.302796 883.970153,765.029847 Z M880,757.888889 C873.863181,757.888889 868.888889,762.863181 868.888889,769 C868.888889,775.136819 873.863181,780.111111 880,780.111111 C886.136093,780.111111 891.111111,775.136093 891.111111,769 C891.111111,762.863907 886.136819,757.888889 880,757.888889 Z M880,778.722222 C874.630537,778.722222 870.277778,774.369463 870.277778,769 C870.277778,763.630537 874.630537,759.277778 880,759.277778 C885.369463,759.277778 889.722222,763.630537 889.722222,769 C889.722222,774.369463 885.369463,778.722222 880,778.722222 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-Message-hover",
    transform: "translate(-868.000000, -757.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icCloseXCircleGreen",
    fill: "#7EC34D",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseXCircleGreen);
export default __webpack_public_path__ + "static/media/icCloseXCircleGreen.e0ca68f46d3c3132e1f07b4d0972da24.svg";
export { ForwardRef as ReactComponent };